import { createSelector } from 'reselect';
import { getTheme } from '../utils/theme';

export const makeGetTheme = () => createSelector(getTheme, theme => theme);

const getPassedTours = appProps => appProps.passedTours || [];
export const makeGetPassedTours = () => createSelector(getPassedTours, passedTours => passedTours);

const getSkippedHelp = appProps => appProps.skippedHelp || [];
export const makeGetSkippedHelp = () => createSelector(getSkippedHelp, skippedHelp => skippedHelp);
